/**
 * Classe responsável por excluir em lotes no grid.
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 30/07/2013
 *
 */


Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.ButtonEventCheckBox = function () {

    this.entity = null;
    this.selector = null;
    this.screenName = null;
    this.valueBtn = null;
    this.id = "buttonEventCheckBox";
    this.className = '';
    this.disabled = false;

    this.setEntity = function (entity) {
        this.entity = entity;
    };

    this.setSelector = function (selector) {
        this.selector = selector;
    };

    this.setScreenName = function (screenName) {
        this.screenName = screenName;
    };

    this.setValueBtn = function () {
        this.valueBtn = "";
    };

    this.setBtnSelector = function(btnSelector) {
        this.btnSelector = btnSelector;
    };

    this.setId = function (id) {
        this.id = id;
    };

    this.setClassName = function(className) {
        this.className = className;
    };

    this.setDisabled = function(disabled) {
        this.disabled = disabled;
    };

    this.checkElementAndWriteHTML = function (selector, html) {

        if (selector !== null) {
            const buttonsContainerSelector = selector + ' .buttonsContainer';
            const buttonsContainer = $(buttonsContainerSelector);
            if(!buttonsContainer.length ) {
                const div = document.createElement('div');
                div.className = 'buttonsContainer';
                $(selector).append(div);
            }

            $(buttonsContainerSelector).append(html);
        }
    };

    this.createBtn = function () {

        try {
            let translatedTitle = '';

            if (this.id === 'buttonEventCheckBox') {
                this.setDisabled(true);
                translatedTitle = Monet.I18n.getResourcesByKey('Greenmile.Grid.Button.deleteSelected');
            } 

            const templateHTML = `<div class="eventCheckBox gridActionDiv">
                <div class="spinner"></div>
                <input type="button" id="${this.id}" class="button ${this.className}" value="${this.valueBtn}" title="${translatedTitle}" ${this.disabled && 'disabled'}/>
            </div>`;

            this.checkElementAndWriteHTML(this.selector, templateHTML);


        } catch(e) {
            (new Monet.Exception.ReturnError(this, "Error on create button", e)).console();
        }

    };

    this.handleButtonDisable = function (entity, enable) {
        const selector = ("#" + entity + " #" + this.id);

        const button = document.querySelector(selector);

        if (this.id != 'buttonEventCheckBox') {
            return;
        }

        if (button && enable) {
            const translatedTitle = Monet.I18n.getResourcesByKey('Greenmile.Grid.BatchDelete.btnValue');
            
            button.setAttribute('title', translatedTitle);
            button.removeAttribute('disabled');
        } else if(button && !enable) {
            const translatedTitle = Monet.I18n.getResourcesByKey('Greenmile.Grid.Button.deleteSelected');

            button.setAttribute('title', translatedTitle);
            button.setAttribute('disabled', 'true');
        }
    };

    this.actionAfterClickButton = function () {

        var message = "Your class need implement is function";
        var error = new Monet.Exception.ReturnError(this, message);

        error.console();
    };

    this.addEventListenners = function () {

        var error = null,
            button = null,
            selector = this.btnSelector || ("#" + this.entity + " #" + this.id);

        try {

            var eventListenerFunction = function (scope) {

                return function () {
                    scope.actionAfterClickButton();
                };
            };

            button = document.querySelector(selector);

            if (button !== null) {

                button.removeEventListener("click", eventListenerFunction(this));
                button.addEventListener("click", eventListenerFunction(this));

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, "Error on add event listenner.");
            error.console();

        }

    };

    this.init = function () {

        this.createBtn();
        this.addEventListenners();
    };

    return this;

};
